import { Box, Flex, Grid, GridItem, Text, Image } from '@chakra-ui/react';

type WishlistBoxProps = {
  data: {
    images: string[];
    title: string;
    type: string;
    dates: string;
  };
};

const WishlistBox = ({ data }: WishlistBoxProps) => {
  return (
    <>
      <Box>
        <Box width={400} height={200} position='relative'>
          <Grid h="200px" templateRows='repeat(4, 1fr)'
              templateColumns='repeat(3, 1fr)' gap={1}>
            <GridItem rowSpan={2} colSpan={2}> 
              <Image borderRadius="25px 0px 0px 25px" src={data.images[0]} alt='First image' />
            </GridItem>
            <GridItem colSpan={1} >
              <Image borderRadius="0px 25px 0px 0px" src={data.images[1]} alt='Second image' />
            </GridItem>
            <GridItem colSpan={1}>
            <Image borderRadius="0px 0px 25px 0px" src={data.images[2]} alt='Third image' />
            </GridItem>
          </Grid>
        </Box>
        <Box>
          <Flex alignItems='center' alignContent="center" justifyContent="flex-start" flexDirection="row">
            <Text fontSize="26px" fontFamily="Montserrat" fontWeight={700}>
              {data.title}
            </Text>
            <Text  marginLeft="10px" marginTop="10px" fontSize="17px" fontFamily="Montserrat" color='#6F6F6F' fontWeight={400}>
              {data.type}
            </Text>
          </Flex>
          <Flex>
            <Text fontSize="17px" color='#6F6F6F' fontWeight={400}>
              {data.dates}
            </Text>
          </Flex>
        </Box>
      </Box>
    </>
  );
};

export { WishlistBox };
